module.exports = __webpack_public_path__ + "img/paintbrush-pencil.b17432a8.svg";